import { HeightOutlined } from '@mui/icons-material'

export default HeightOutlined
